<div class="page">
  <div class="subheader header">
    <i class="icon-angle-double-left close-fa" (click)="salonorder.order.closeSidebar()"></i>
    <div class="headertable">
      <i class="usericon icon-table3"> </i
      ><span class="title-header">{{ "ClientApp.FrontOffice.Order.OrderPage.Fastaccess.SalonFastacces.TitleHeader" | translate }}</span>
    </div>
    <i class="icon-th"></i>
  </div>
  <div class="contentbox">
    <div class="tablegroup">
      <div
        class="saloncard"
        *ngFor="let salon of salonorder._salons"
        (click)="salonorder.getTablesRead(salon)"
        [class.selecteditem]="salon === salonorder.selectedSalons">
        <span class="number">{{ salon.Title }}</span>
      </div>
    </div>
    <div class="condition">
      <ul class="tablestate group" *ngFor="let item of salonorder.tableFilter; trackBy: salonorder.trackByFn">
        <li
          class="statename d-flex align-items-center tablecondition"
          (click)="item.selected = !item.selected; salonorder.tableFilterByStatus()"
          [ngClass]="{
            statusClickedBg: item.selected,
            freeStatus: item.key === 1,
            orderingStatus: item.key === 2,
            clearingStatus: item.key === 3,
            timeOverStatus: item.key === 4
          }">
          <div class="color-condition"></div>
          {{ item.title }} {{ item.count }}
        </li>
      </ul>
    </div>
    <div class="cardbox">
      <div *ngIf="salonorder._tempTableReads" class="tablecard">
        <div
          class="card subinfocall callcard"
          *ngFor="let table of salonorder._tempTableReads"
          (click)="salonorder.SelectTable(table); salonorder.order.closeSidebar()"
          [ngClass]="{ lockedTable: table.Locked }">
          <div class="callcontent">
            <div>{{ table.Title }}</div>
            <div class="line">
              <div>
                <span *ngIf="table.Status !== 1">{{ table.RelativeInvoiceTimeString }}</span>
                <span *ngIf="table.Status === 1">-- : --</span>
              </div>
              <div
                class="colorcard"
                [ngClass]="{
                  gray: table.Status === salonorder._tableStatus.Free,
                  blue: table.Status === salonorder._tableStatus.Ordering,
                  green: table.Status === salonorder._tableStatus.Clearing,
                  red: table.Status === salonorder._tableStatus.TimeOver
                }"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
